import { MCBPS050QueryRequest } from 'types/MCBPS050/MCBPS050QueryRequest'
import request from 'utils/request'

export const initApi = (param: MCBPS050QueryRequest) =>
  request({
    url: `/MCBPS050/init`,
    method: 'post',
    data: param
  })